import { render, staticRenderFns } from "./AnnounceScreen.vue?vue&type=template&id=2e22ee60&scoped=true&"
import script from "./AnnounceScreen.vue?vue&type=script&lang=js&"
export * from "./AnnounceScreen.vue?vue&type=script&lang=js&"
import style0 from "./AnnounceScreen.vue?vue&type=style&index=0&id=2e22ee60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e22ee60",
  null
  
)

export default component.exports